const config = {
  appName: "CALMAN",
  // URI: "http://localhost:8080/mainman_dev/",
  // URI: "http://192.168.29.19:8080/techapps/",
  // URI: "https://api.teraobjects.com/mainman/",
  URI: "https://calman-api.calmansaudi.com/mainman/",
  // URI: "https://api.techenablesme.com/mainman_dev/",
  // URI: process.env.REACT_APP_API_URL,
  GOOGLE_TRANSLATE_API_URL: "https://translation.googleapis.com/language/translate/v2",
  GOOGLE_CLOUD_API_KEY: "AIzaSyAMYoBuJMw3IhRX7m26AHqmMA8Y0NUgDsc",
};

export default config;
